const getYouTubeId = ( url = '' ) => {
  const matches = url.match(/(?:youtube(?:-nocookie)?\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i);
  return {
    videoId: matches[1]
  };
}

const getVimeoId = ( url = '' ) => {
  // Original REGEX: /(?:http|https)?:?\/?\/?(?:www\.)?(?:player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|video\/|)([\d]+)(?:|\/|\/\?)([0-9a-f]+)?/i
  // This simplified regex takes into account if there is a unlilsted hash after the video ID
  const matches = url.match(/(?:http|https)?:?\/?\/?(?:www\.)?(?:player\.)?vimeo\.com\/(?:video\/|)([\d]+)\/?([0-9a-f]+)?/i);
  return {
    videoId: matches[1],
    hash: matches[2]
  };
}

export { getVimeoId, getYouTubeId };
